import React, { useEffect, useState } from "react";
import {
  Grid,
  MenuItem,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Checkbox,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Box,
  CircularProgress,
  Typography,
} from "@material-ui/core";

import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";

import { useFetchContext } from "../../../common/FetchContext";
import { useAvailableCheckList, useCheckList } from "../../projectManagementQueries";
import { CheckListNotes } from "./CheckListNotes";
import { useCheckListAddNotes, useUpdateCheckListAddNotes } from "../../../common/CommonQueries";
import { toast } from "react-toastify";
import { PendingDialogComponent } from "./PendingDialogComponent";

export const CheckList = ({ id, refetch, open, onClose, is_writer, is_superuser }: any) => {
  const { authAxios } = useFetchContext();

  const [isAvailable, setIsAvailable] = useState(true);
  const [Category, setCategory] = useState<any>("");
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [statusData, setStatusData] = useState<any[]>([]);
  const [UpdateStatusData, setUpdateStatusData] = useState<any[]>([]);

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [selectedReportId, setSelectedReportId] = useState<number | null>(null);
  const [selectedReportIndex, setSelectedReportIndex] = useState<number | null>(null);

  const {
    data: availableCheckListdata,
    isLoading: isLoadingAvailableCheckList,
    isError: isAvailableCheckListError,
    error: availableCheckListError,
    refetch: refetchAvailableCheckList,
  } = useAvailableCheckList(id);

  const {
    data: checkListdata = [],
    isLoading: isLoadingWriterReports,
    refetch: refetchCheckList,
  } = useCheckList({
    enabled: false, // prevent auto-run
  });

  useEffect(() => {
    if (availableCheckListdata && availableCheckListdata[0].check_list.length === 0) {
      refetchCheckList();
      setIsAvailable(false);
    } else if (availableCheckListdata && availableCheckListdata.length > 0) {
      setIsAvailable(true);
    }
  }, [availableCheckListdata, refetchCheckList]);



  const { mutateAsync: mutate, isLoading: isLoadingChecklist } = useCheckListAddNotes();
  const { mutateAsync: mutateUpdate, isLoading: isLoadingChecklistupdate } = useUpdateCheckListAddNotes();

  if (isLoadingWriterReports) return <LinearProgress />;



  const handleCloseDialog = () => {
    setCategory("");
    setStatusData([]);
    setSelectedIndex(null);
    setSelectedCategoryId(null);
    onClose();
  };


  const handleCategories = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedCategoryIndex = Number(event.target.value);
    const selectedCategory = checkListdata[selectedCategoryIndex];

    setCategory(selectedCategoryIndex);
    setSelectedIndex(selectedCategoryIndex);
    setSelectedCategoryId(selectedCategory?.id ?? null);

    // flatten checkpoints
    const initialStatus: any[] = [];
    selectedCategory?.checklist?.forEach((section: any) => {
      section.check_point.forEach((item: any) => {
        initialStatus.push({ id: item.id, status: null });
      });
    });

    setStatusData(initialStatus);
  };


  const handleStatusChange = (id: number) => {
    setStatusData((prev) => {
      const existing = prev.find(item => item.id === id);
      let newStatus = true;

      if (existing) {
        switch (existing.status) {
          case 'none':
            newStatus = true;
            break;
          case true:
            newStatus = false;
            break;
          case false:
            newStatus = true;
            break;
        }

        return prev.map(item =>
          item.id === id ? { ...item, status: newStatus } : item
        );
      } else {
        return [...prev, { id, status: true }];
      }
    });
  };


  const handleUpdateStatusChange = (id: number, checked: boolean) => {
    setUpdateStatusData((prev) => {
      // If the id already exists, update its status
      const existing = prev.find((s) => s.id === id);
      if (existing) {
        return prev.map((s) =>
          s.id === id ? { ...s, status: checked } : s
        );
      }
      // If not exists, add it
      return [...prev, { id, status: checked }];
    });
  };


  const handleUpdate = async () => {
    const payload = {
      report_id: id,
      checklist_report_id: availableCheckListdata?.[0]?.category_id,
      checklist_data: UpdateStatusData.map((item) => ({
        id: item.id,
        status: item.status,
      })),
    };
    try {
      await mutateUpdate({
        report_result_id: id,
        category_id: availableCheckListdata?.[0]?.category_id,
        checklist_data: UpdateStatusData.map((item) => ({
          id: item.id,
          status: item.status,
        })),
        authAxios,
      });

      toast.success("CheckList Updated Successfully !");
      handleCloseDialog();
      await refetch();
    } catch (error: any) {
      const message = error?.response?.data?.error || "Error while updating CheckList";
      console.error(error);
      toast.error(message);
    }



  };



  const handleSubmit = async () => {
    const hasInvalidStatus = statusData.some(item => item.status !== true && item.status !== false);

    if (hasInvalidStatus) {
      toast.error("All checklist items must be either checked or unchecked . Please complete the checklist before submitting.");
      return;
    }
    const payload = {
      report_result_id: id,
      category_id: selectedCategoryId,
      checklist_data: statusData,
    };

    try {
      await mutate({
        report_result_id: id,
        category_id: selectedCategoryId,
        checklist_data: statusData,
        authAxios,
      });

      toast.success("CheckList Added Successfully !");
      handleCloseDialog();
      await refetch();
    } catch (error: any) {
      const message = error?.response?.data?.error || "Error while Adding CheckList";
      console.error(error);
      toast.error(message);
    }


  };


  return (

    <Grid container justifyContent="center" spacing={2}>
      {isAvailable ? (
        <>

          <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
            <DialogTitle>Check List</DialogTitle>
            <DialogContent>
              {isLoadingAvailableCheckList ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="200px"
                  width="100%"
                >
                  <CircularProgress size={40} />
                </Box>
              ) : (
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={12}>
                    <PendingDialogComponent id={id} is_writer={is_writer} />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="report"
                      name="report"
                      label="Reports"
                      value={availableCheckListdata?.[0]?.report_name ?? ""}
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ color: "red" }}>* Notes are required when the checkbox is unchecked or false.*</Typography>

                  </Grid>

                  <Grid item xs={12}>
                    <TableContainer
                      component={Paper}
                      style={{
                        marginTop: 16,
                        border: "2px solid #B0B0B0",
                        borderRadius: 8,
                        padding: 18,
                      }}
                    >
                      <Table size="small">
                        <TableBody>
                          {availableCheckListdata?.[0].check_list?.map((checkList: any) => (
                            <React.Fragment key={checkList.category}>

                              <TableRow style={{ backgroundColor: "#FFC107", height: 30 }}>
                                <TableCell
                                  colSpan={3}
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {checkList.category}
                                </TableCell>
                              </TableRow>


                              {checkList.check_point?.map((item: any) => (
                                <TableRow key={item.id} style={{ height: 30 }}>
                                  <TableCell padding="none" style={{ marginLeft: 20 }}>{item.description}</TableCell>

                                  <TableCell align="center" padding="none">
                                    <Checkbox
                                      checked={
                                        (UpdateStatusData.find((s: any) => s.id === item.id)?.status ?? item.status) === true
                                      }
                                      indeterminate={
                                        (UpdateStatusData.find((s: any) => s.id === item.id)?.status ?? item.status) === false
                                      }
                                      onChange={(e) => handleUpdateStatusChange(item.id, e.target.checked)}
                                      style={{
                                        color:
                                          (UpdateStatusData.find((s: any) => s.id === item.id)?.status ?? item.status) === false
                                            ? "red"
                                            : "green",
                                      }}
                                      disabled={is_superuser ? false : !is_writer}
                                    />

                                  </TableCell>

                                  <TableCell align="center" padding="none">
                                    <IconButton>
                                      <CheckListNotes
                                        id={id}
                                        check_list_report_id={availableCheckListdata?.[0]?.category_id}
                                        check_list_id={item.id}
                                        count={item.note_count}
                                        Writer={true}
                                      />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </React.Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>

              )}

            </DialogContent>


            <DialogActions>
              <Button onClick={handleCloseDialog} variant="outlined">
                Cancel
              </Button>

              <Button
                color="primary"
                variant="outlined"
                onClick={handleUpdate}
                disabled={isLoadingChecklistupdate}
              >
                {isLoadingChecklistupdate ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update"
                )}
              </Button>
            </DialogActions>
          </Dialog>


        </>
      ) : (
        <>
          {open && (
            <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
              <DialogTitle>Check List</DialogTitle>
              <DialogContent>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={4}>
                    <TextField
                      id="Category"
                      name="Category"
                      label="Categories"
                      select
                      value={Category}
                      onChange={handleCategories}
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      disabled={Category !== ""}
                    >
                      {Array.isArray(checkListdata) &&
                        checkListdata.map((item: any, index: number) => (
                          <MenuItem key={item.id} value={index}>
                            {item.report_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  {Category !== "" && selectedIndex !== null && checkListdata[selectedIndex] && (
                    <Grid item xs={12}>
                      <Grid item xs={12}>
                        <Typography variant="body1" style={{ color: "red" }}>* Notes are required when the checkbox is unchecked or false.*</Typography>
                      </Grid>
                      <TableContainer
                        component={Paper}
                        style={{
                          marginTop: 16,
                          border: "2px solid #B0B0B0",
                          borderRadius: 8,
                          padding: 18,
                        }}
                      >
                        <Table size="small">
                          <TableBody>
                            {checkListdata[selectedIndex].checklist.map((checkList: any) => (
                              <React.Fragment key={checkList.category}>
                                <TableRow style={{ backgroundColor: "#FFC107", height: 30 }}>
                                  <TableCell colSpan={3} align="center" style={{ fontWeight: "bold" }}>
                                    {checkList.category}
                                  </TableCell>
                                </TableRow>

                                {checkList.check_point.map((item: any) => (
                                  <TableRow key={item.id} style={{ height: 30 }}>
                                    <TableCell padding="none">{item.description}</TableCell>

                                    <TableCell align="center" padding="none">
                                      <Checkbox
                                        checked={statusData.find(i => i.id === item.id)?.status === true}
                                        indeterminate={statusData.find(i => i.id === item.id)?.status === false}
                                        onChange={() => handleStatusChange(item.id)}
                                        style={{
                                          color:
                                            statusData.find(i => i.id === item.id)?.status === false
                                              ? 'red'
                                              : 'green',
                                        }}
                                      />
                                    </TableCell>

                                    <TableCell align="center" padding="none">
                                      <IconButton>
                                        <CheckListNotes id={id} type={1} model={"report"} check_list_report_id={selectedCategoryId} check_list_id={item.id} Writer={true} />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </React.Fragment>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDialog} variant="outlined">
                  Cancel
                </Button>

                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleSubmit}
                  disabled={isLoadingChecklist}
                >
                  {isLoadingChecklist ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "submit"
                  )}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}

    </Grid>
  );
};
